export type TemplateControlColor = 'dark' | 'light';

export function templateControlColorFrom(textColor: string): TemplateControlColor {
  const normalizedColor: string = textColor.trim().toLowerCase();

  if (normalizedColor === '#fff' || normalizedColor === '#ffffff' || normalizedColor === 'white')
    return 'light';

  if (normalizedColor === '#000' || normalizedColor === '#000000' || normalizedColor === 'black')
    return 'dark';

  const rgbColor: [number, number, number] | null = hexToRgb(normalizedColor);
  if (!rgbColor) return 'dark';

  const [red, green, blue]: [number, number, number] = rgbColor;
  const luminance: number = (0.299 * red + 0.587 * green + 0.114 * blue) / 255;

  return luminance > 0.6 ? 'dark' : 'light';
}

function hexToRgb(color: string): [number, number, number] | null {
  const normalizedColor: string = color.startsWith('#') ? color.slice(1) : color;
  if (![3, 6].includes(normalizedColor.length)) return null;
  if (!/^[0-9a-f]+$/i.test(normalizedColor)) return null;

  const expandedColor: string =
    normalizedColor.length === 3
      ? normalizedColor
          .split('')
          .map((hexDigit: string) => hexDigit + hexDigit)
          .join('')
      : normalizedColor;

  return [
    parseInt(expandedColor.slice(0, 2), 16),
    parseInt(expandedColor.slice(2, 4), 16),
    parseInt(expandedColor.slice(4, 6), 16),
  ];
}
